import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { VAT } from "src/config/priceTypeList";

interface IPayTermProps {
  priceType: string;
  userPerPrice: number;
  userPerPriceYear: number;
  currency: string;
}
// 결제 주기
const PayTerm = ({
  priceType,
  userPerPrice,
  userPerPriceYear,
  currency,
}: IPayTermProps) => {
  const { register, watch } = useFormContext();
  const payTerm = watch("payTerm");
  const licenseCount = watch("licenseCount");
  const { t } = useTranslation();
  return (
    <Form.Group className="mb-4">
      <Form.Label>
        {priceType && t(`siteType.${priceType}.detail.plan.paymentCycle`)}
      </Form.Label>

      {["month", "year"].map((term) => {
        const isMonthly = term === "month";
        const selected = payTerm === term;
        const value = isMonthly ? userPerPrice : userPerPriceYear;
        const annualValue = value * 12 * licenseCount * VAT;
        const labelClass =
          "label-group label-group--box height h-76" +
          (isMonthly ? " mg mb-10" : " relative");
        const payTypeKey = isMonthly ? "payType_month" : "payType_annual";

        return (
          <label key={term} className={labelClass} data-is-active={selected}>
            <input
              type="radio"
              id={term}
              className="form-control custom-form"
              value={term}
              {...register("payTerm")}
            />
            <div className="pd pr-10 width min-w-100">
              <span className="text text--lg">
                {priceType &&
                  t(`siteType.${priceType}.detail.plan.${payTypeKey}`)}
              </span>
            </div>
            <div>
              {priceType &&
                t(`siteType.${priceType}.detail.plan.price_condition_per_user`)}
              <NumberFormat currency={currency} num={value} />
              {priceType &&
                t(`siteType.${priceType}.detail.plan.price_condition_monthly`)}
              <br />
              <span className="text weight--350">
                {priceType && t(`siteType.${priceType}.detail.plan.annual_sum`)}
                &nbsp;
                <NumberFormat num={annualValue} currency={currency} />
              </span>
            </div>
            {!isMonthly && (
              <span className="label label--green absolute">
                -&nbsp;
                <NumberFormat
                  num={
                    (userPerPrice - userPerPriceYear) * licenseCount * 12 * VAT
                  }
                  currency={currency}
                />
              </span>
            )}
          </label>
        );
      })}
    </Form.Group>
  );
};

export default PayTerm;
